"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSalt = void 0;
const ethers_1 = require("ethers");
const generateSalt = () => {
    const randomSeed = Math.floor(Math.random() * 1000000);
    const dataEncoded = ethers_1.AbiCoder.defaultAbiCoder().encode(["uint256", "uint256"], [randomSeed, new Date().getMilliseconds()]);
    return (0, ethers_1.keccak256)(dataEncoded);
};
exports.generateSalt = generateSalt;
